import { uploadImage } from '@buzzfeed/bf-utils/lib/island';

const getBFPFields = (bfp) => {
  return {
    id: bfp.id,
    format_name: bfp.format_name,
    data: {
      promotion: bfp.data?.promotion,
      source: bfp.data?.source,
      type: bfp.data?.type,
      intro: bfp.data?.intro,
    },
  };
};

const createArtifactShareFields = async ({
  source = 'widget',
  contentObject,
  caption,
  image,
  imageUrl = '',
}) => {
  // @Chat-TODO - error handling
  let uploadedImageUrl = '';

  if (source === 'widget') {
    // if URL already exists, use that, otherwise upload image to CDN to get image URL
    if (imageUrl) {
      uploadedImageUrl = imageUrl;
    } else {
      const imageData = await uploadImage(image);
      const { url } = imageData;
      uploadedImageUrl = url;
    }
  } else if (source === 'artifact') {
    uploadedImageUrl = contentObject.content?.promotion?.thumbnail?.url;
  }

  const ownerProfile = contentObject?.owner_profile || {};

  // create attachments for chat messages
  const extraData = {
    type: 'artifact',
    source,
    bfp: getBFPFields(contentObject.content?.bfp || {}),
    owner_profile: {
      avatar: ownerProfile.avatar,
      display_name: ownerProfile.display_name,
      username: ownerProfile.username,
    },
    image: uploadedImageUrl,
    caption,
    parentContentObjectId:
      source === 'widget'
        ? contentObject.id
        : contentObject?.content?.single_comment?.content_id,
  };

  if (source === 'artifact') {
    extraData.contentObjectId = contentObject.id;
  }
  const attachments = [
    {
      type: 'artifact',
      extraData,
    },
  ];

  // create data if publish to public field/profile
  const publishFields = {
    caption,
    title: contentObject.content?.bfp?.data?.intro?.card?.title,
    bfpId: contentObject.content?.bfp?.id,
  };
  if (source === 'widget') {
    publishFields.contentObjectId = contentObject.id;
  }

  return {
    attachments,
    imageUrl: uploadedImageUrl,
    publishFields,
    customType: 'artifact',
  };
};

const createWidgetShareFields = ({ contentObject }) => {
  const ownerProfile = contentObject?.owner_profile || contentObject?.ownerProfile || {};
  const attachments = [
    {
      type: 'widget',
      extraData: {
        contentObjectId: contentObject.id,
        bfp: getBFPFields(contentObject?.content?.bfp || {}),
        owner_profile: {
          avatar: ownerProfile.avatar,
          display_name: ownerProfile.display_name,
          username: ownerProfile.username,
        },
      },
    },
  ];

  const publishFields = {
    title: contentObject.content?.bfp?.data?.promotion?.description,
    contentObjectId: contentObject.id,
  };

  return {
    imageUrl: contentObject.content?.bfp?.data?.promotion?.thumbnail?.url,
    attachments,
    customType: 'widget',
    publishFields,
  };
};

const createRiffShareFields = async ({
  widgetContentObjectId,
  caption,
  image,
  originalImageUrl = '',
  originalMessageId = null,
  bfp,
  ownerProfile,
  source,
}) => {
  // @Chat-TODO - error handling
  let uploadedImageUrl = '';

  // Upload image to CDN to get image URL
  const imageData = await uploadImage(image);
  const { url, width, height } = imageData;
  uploadedImageUrl = url;

  // create attachments for chat messages
  const extraData = {
    type: 'riff',
    bfp,
    owner_profile: ownerProfile,
    imageUrl: uploadedImageUrl,
    imageWidth: width,
    imageHeight: height,
    caption,
    originalImageUrl,
    originalMessageId,
    widgetContentObjectId,
    source,
  };

  const attachments = [
    {
      type: 'riff',
      extraData,
    },
  ];

  return { attachments, imageUrl: uploadedImageUrl, customType: 'riff' };
};

export {
  createArtifactShareFields,
  createWidgetShareFields,
  createRiffShareFields,
};
